<template>
  <section class="content">

    <!--robot type-->
    <div>
      <div v-show="macRobotList.length>0" class="robot-list-type">Mac Robot</div>

      <div class="agent-list" v-for="item in macRobotList">
        <div class="row">

          <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3">

            <img class="device-user-list-portrait" v-if="item.icon == ''"
                 src="../../../static/img/img_app_list_icon_default.png">
            <img class="device-user-list-portrait" v-else v-bind:src="'https://d.din.bz/'+item.icon">
          </div>

          <div class="col-lg-11 col-md-10 col-sm-10 col-xs-9 device-user-list-data">
            <p class="device-user-list-username">{{item.name}}</p>
            <div class="col-lg-2 col-md-3 col-sm-3 col-xs-4">
              <span class="robot-list-status label label-default" v-if="item.isOnline == false">offline</span>
              <span class="robot-list-status label label-info" v-else-if="item.task == 0">free</span>
              <span class="robot-list-status label label-warning" v-else-if="item.task > 0">building</span>
            </div>
            <div class="col-lg-10 col-md-9 col-sm-9 col-xs-8" v-if="item.task > 0">
              <p> {{$route.query.appname}} - v{{item.currentVersion}} build {{item.currentBuild}} ({{item.currentTime / 1000000 | formatDate}})</p>
              <p class="robot-list-task-wait"><i class="fa fa-thumb-tack"></i>&nbsp;&nbsp;<span
                class="robot-list-task-num">{{item.task - 1}}</span>&nbsp;task waiting...</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <!--/ robot type-->
 <div>
      <div v-show="deviceRobotList.length>0" class="robot-list-type">Device Robot</div>

      <div class="agent-list" v-for="item in deviceRobotList">
        <div class="row">

          <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3">

            <img class="device-user-list-portrait" v-if="item.icon == ''"
                 src="../../../static/img/img_app_list_icon_default.png">
            <img class="device-user-list-portrait" v-else v-bind:src="'https://d.din.bz/'+item.icon">
          </div>

          <div class="col-lg-11 col-md-10 col-sm-10 col-xs-9 device-user-list-data">
            <p class="device-user-list-username">{{item.name}}</p>
            <div class="col-lg-2 col-md-3 col-sm-3 col-xs-4">
              <span class="robot-list-status label label-default" v-if="item.isOnline == false">offline</span>
              <span class="robot-list-status label label-info" v-else-if="item.task == 0">free</span>
              <span class="robot-list-status label label-warning" v-else-if="item.task > 0">building</span>
            </div>
            <div class="col-lg-10 col-md-9 col-sm-9 col-xs-8" v-if="item.task > 0">
              <p> {{$route.query.appname}} - v{{item.currentVersion}} build {{item.currentBuild}} ({{item.currentTime / 1000000 | formatDate}})</p>
              <p class="robot-list-task-wait"><i class="fa fa-thumb-tack"></i>&nbsp;&nbsp;<span
                class="robot-list-task-num">{{item.task - 1}}</span>&nbsp;task waiting...</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>
<script>
import api from '../../api'
import utils from '../../utils'
import global from '../Global.vue'
import config from '../../config'

export default {
  name: 'RobotList',
  data () {
    return {
      robotStatus: 1,
      deviceRobotList: [],
      macRobotList: []
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
  },
  methods: {
    init () {
      var params = new URLSearchParams()
      var jsons = {
        _lindex: 0,
        _limit: 0,
        isonline: 1
      }
      params.append('json', utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET))
      if (window.localStorage) {
        params.append('token', this.$router.app.$store.state.user.token)
      }
      api.requestWithServerUrl('post', config.asServerURI, '/compilation/robotlist?_type=json', params)
        .then(response => {
          var data = response.data
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              this.deviceRobotList = []
              this.macRobotList = []
              var robotlist = JSON.parse(utils.getDecodeRC4Hex(data.Result, global.APP_SECRET))
              for (var i = 0; i < robotlist.length; i++) {
                if (robotlist[i].type === global.DEVICE_TYPE) {
                  this.deviceRobotList.push(robotlist[i])
                }
                if (robotlist[i].type === global.MAC_TYPE) {
                  this.macRobotList.push(robotlist[i])
                }
              }
            }
          }
        })
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return utils.formatDate(date, 'yyyy.MM.dd')
    }
  }
}

</script>


<style>
</style>



// WEBPACK FOOTER //
// RobotList.vue?4a88ec2e